import { render, staticRenderFns } from "./TabelaServicoProposta.vue?vue&type=template&id=2598d126&"
import script from "./TabelaServicoProposta.vue?vue&type=script&lang=js&"
export * from "./TabelaServicoProposta.vue?vue&type=script&lang=js&"
import style0 from "./TabelaServicoProposta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports